var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"customers"},[_c('div',{staticClass:"content-wrapper"},_vm._l((_vm.partners),function(partner){return _c('img',{key:partner.name,attrs:{"alt":partner.name,"src":partner.src}})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }